<template>
  <b-card no-body>
    <div class="h-100 py-3 d-flex flex-column justify-content-between">
      <div class="d-flex align-items-baseline justify-content-center px-0">
        <div v-if="loading">
          <div class="d-flex align-items-center justify-content-center">
            <b-skeleton
              class="rounded-circle mr-0"
              width="140px"
              height="140px"
            ></b-skeleton>
          </div>
          <div class="d-flex align-items-center justify-content-center mt-1">
            <b-skeleton width="40px" height="15px" class="mx-50"></b-skeleton>
            <b-skeleton width="40px" height="15px" class="mx-50"></b-skeleton>
          </div>
        </div>
        <div
          class="py-2"
          v-else-if="
            dashboard.most_symbol_trades && dashboard.most_symbol_trades.length
          "
        >
          <doughnut-chart
            :chartData="chartData"
            :colors="['#FA4B68', '#2CD889', '#FBAD25', '#39A4F8']"
            :labels="[...labels]"
            height="160px"
            width="160px"
          />
        </div>
        <template v-else>
         <div class="d-flex justify-content-center h-100 new-alert">
          <div
            class="mt-2"
            style="
              border-radius: 100px;
              height: 115px;
              width: 115px;
              border: 23px solid rgb(45 45 53 / 44%);
            "
          > </div> 
        </div>
        </template>
      </div>
      <div
        class="px-1 d-flex flex-column justify-content-center align-items-center"
      >
        <h2 class="pb-0 font-weight-bolder text-white mb-2">
          Most traded symbols
        </h2>
        <b-card-text class="text-center mb-1">
          click to see the full report and detailed status of the symbols you've
          traded.
        </b-card-text>
        <!-- <b-button class="text-muted py-1"
          ><span class="mr-1">See details</span>
          <feather-icon icon="ArrowRightIcon" />
        </b-button> -->
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BButton,
  BImg,
  BSkeleton,
  BAlert,
} from "bootstrap-vue";

import DoughnutChart from "@/views/components/doughnut-chart/DoughnutChart.vue";
export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BButton,
    BImg,
    DoughnutChart,
    BSkeleton,
    BAlert,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    dashboard: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    labels() {
      return [
        ...this.dashboard.most_symbol_trades
          .map((item) => item.symbol || "-")
          .slice(0, 4),
      ];
    },
    chartData() {
      return [
        ...this.dashboard.most_symbol_trades
          .map((item) => item.count)
          .slice(0, 4),
      ];
    },
  },
};
</script>
